<template>
  <div
    class="input-block"
    :style="value.borderColor"
  >
    <div class="input-block__topLine">
      <div v-show="arrayLength>1">
        <slot name="leftBtn"></slot>
      </div>
      <span
        v-if="_isCreateVersion || _isNewTopic"
        class="input-block__topicLine__alertText"
      >{{`${_isCreateVersion}${_isNewTopic}`}}</span>
      <span>{{title}}</span>
      <div
        v-if="showTitle"
        class="input-block__topicLine__title-content"
      >
        <p>{{_titleContent}}</p>
      </div>
      <WsState
        v-else
        :rules="'required'"
        :value="value"
        @input="$emit('input',$event)"
      ></WsState>
      <slot name="content"></slot>
      <div class="input-block__topLine__Btn">
        <slot name="rightBtn"></slot>
        <div v-if="isTopicList">
          <WsIconBtn
            v-if="value.openActive"
            :size="40"
            class="ml-1 mr-1"
            tooltip="收合"
            @click="$_readActiveToggle()"
          >
            mdi-unfold-less-horizontal
          </WsIconBtn>
          <WsIconBtn
            v-else
            :size="40"
            tooltip="展開"
            class="ml-1 mr-1"
            @click="$_readActiveToggle()"
          >
            mdi-unfold-more-horizontal
          </WsIconBtn>
        </div>
        <WsIconBtn
          v-show="itemVersionCreatable"
          :size="40"
          @click="$_onCreateVersion()"
          tooltip="更新版本"
        >mdi-update</WsIconBtn>
        <WsIconBtn
          v-show="arrayLength>1"
          @click="$emit('deleteList')"
          :size="40"
          class="ml-1 mr-1"
          tooltip="刪除"
        >mdi-delete</WsIconBtn>
      </div>
    </div>
    <div
      class="input-block__detail"
      v-show="value.openActive"
    >
      <slot name="detail">
        <div
          v-if="isLoading"
          class="loading-section"
        >
          <v-skeleton-loader
            v-for="n in 1"
            :key="`skeleton-${n}`"
            type="list-item-three-line"
            :tile="true"
            class="mt-5"
          ></v-skeleton-loader>
        </div>
        <WsStateForm
          v-if="modelData || value.isNewTopic"
          :generalFields="fields"
          :detect="value.openActive"
          :modelData="modelData"
          @isCompleted="$_isFormCompleted($event,value)"
          :customParentData="customParentData"
          :value="value"
          @input="$_onInput($event)"
        ></WsStateForm>
      </slot>
    </div>
  </div>

</template>
<script>
export default {
  name: "InputBlock",
  data: () => ({
    versionModelData: {},
    modelData: null,
    titleContent: "",
    C_value: "",
    isLoading: false,
    alreadyFetch: false,
  }),
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number, Object],
      default: null,
    },
    slickIndex: {
      type: Number,
      default: 0,
    },
    arrayLength: {
      type: Number,
      default: 0,
    },
    fields: {
      type: Object,
      default() {
        return {};
      },
    },
    modelName: {
      type: String,
      default: "",
    },
    updateData: {
      type: Object,
      default: null,
    },
    versionModelName: {
      type: String,
      default: "",
    },
    customParentData: {
      type: Object,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    isTopicList: {
      type: Boolean,
      default: false,
    },
    itemVersionCreatable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async $_fetchData() {
      this.C_value = JSON.parse(JSON.stringify(this.value));
      if (
        !this.value.openActive ||
        !this.value.id ||
        this.alreadyFetch ||
        this.value.isNewTopic
      )
        return;
      try {
        this.isLoading = true;
        const getModelUrl = `/${this.modelName}/${this.value.id}`;
        const ModelRes = await this.$axios.get(getModelUrl);
        this.C_value = JSON.parse(JSON.stringify(ModelRes.data.data));
        this.modelData = ModelRes.data.data;
        try {
          const getVersionModelUrl = `/${this.versionModelName}/${ModelRes.data.data.last_version.id}`;
          const versionModelRes = await this.$axios.get(getVersionModelUrl);
          this.versionModelData = versionModelRes.data.data;
          this.isLoading = false;
          this.alreadyFetch = true;
        } catch (error) {
          this.isLoading = false;
          alert(error);
        }
      } catch (error) {
        this.isLoading = false;
        alert(error);
      }
    },
    $_onInput($event) {
      this.C_value = {
        ...this.C_value,
        ...$event,
      };
      this.$emit("input", this.C_value);
    },
    $_onClick() {
      this.$refs.fileInput.click();
    },
    $_isFormCompleted(isCompleted, value) {
      value.borderColor = isCompleted
        ? ""
        : "border:2px solid #f04526;border-left:8px solid #f04526";
    },
    $_readActiveToggle() {
      this.$emit("activeToggle", !this.value.openActive);
    },
    $_onCreateVersion() {
      this.$emit("createVersionClick");
    },
  },
  computed: {
    _titleContent() {
      let title = "";
      if (this.value.last_version.locales) {
        if (
          this.value.last_version.locales[
            this.$store.state.locale.selectingLocale
          ]
        ) {
          title =
            this.value.last_version.locales[
              this.$store.state.locale.selectingLocale
            ]["title"];
        }
      } else {
        title = this.versionModelData.title;
      }

      return title;
    },
    _isCreateVersion() {
      if (this.value.isCreateVersion) {
        return "UPDATE";
      } else {
        return "";
      }
    },
    _isNewTopic() {
      if (this.value.isNewTopic) {
        return "NEW";
      } else {
        return "";
      }
    },
  },
  watch: {
    value: {
      handler() {
        if (this.value.openActive) {
          this.$_fetchData();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.$_fetchData();
  },
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/input-block.scss";
</style>